/** @format */

import React from 'react';
import { Popup } from 'react-map-gl';
import DispatchContext from '../../DispatchContext';
import StateContext from '../../StateContext';
import { useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import {
	styleGray,
} from '../Utils/constants.js';
import './mobile-popup.css';

export type StationObject = {
	lngLat: [number, number];
	name: string;
	code?: string;
	river?: string;
	basin?: string;
	anomalia?: string;
	sat?: string;
	change?: string;
	level?: string;
	sdate?: string;
	edate?: string;
};

type StPopupProp = {
	sObj: StationObject;
	getData(name: string): void;
	closePopup(): void;
};

const MobilePopup = (props: StPopupProp) => {
	const appState = useContext(StateContext);
	const appDispatch = useContext(DispatchContext);

	const BootstrapButton = styled(Button)({
		boxShadow: 'none',
		textTransform: 'none',
		fontSize: 14,
		padding: '6px 12px',
		border: '1px solid',
		lineHeight: 1.5,
		backgroundColor: styleGray.bgButton,
		borderColor: styleGray.borderColor,
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		'&:hover': {
			backgroundColor: styleGray.bgButtonHover,
			borderColor: styleGray.borderColorHover,
			boxShadow: 'none',
		},
		'&:active': {
			boxShadow: 'none',
			backgroundColor: styleGray.bgButtonActive,
			borderColor: styleGray.borderColorActive,
		},
		'&:focus': {
			boxShadow: styleGray.boxShadowFocus,
		},
	});

	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: 'center',
		fontSize: '0.7rem',
        textWrap: 'wrap',
        color: theme.palette.text.secondary,
	}));
	return (
		<Popup
			// @ts-ignore
			tipSize={5}
			longitude={props.sObj.lngLat[0]}
			latitude={props.sObj.lngLat[1]}
			closeOnClick={false}
			offset={{
				'bottom-left': [12, -20],
				bottom: [0, -20],
				'bottom-right': [-12, -20],
			}}
			onClose={() => {
				props.closePopup();
				appDispatch({
					type: 'showDrainageArea',
					valueShow: false,
				});
			}}
			className="mobile-custom-popup"
		>
			{/* Customize the content of the popup */}
			<div>
				<h3 style={{ fontSize: '0.875rem'}}>
					{appState.stationData.river} {props.sObj.code}
				</h3>
				<Box sx={{ flexGrow: 1 }}>
					<Grid container spacing={0.5}>

						<Grid item xs={4}>
							<Item>Level: {props.sObj.level}(m)</Item>
						</Grid>
						<Grid item xs={8}>
							<Item><div>Change/Anomaly:</div> <span style={{textWrap: 'nowrap'}}>{props.sObj.change}(m) /  {Number(props.sObj.anomalia).toFixed(1)}(m)</span></Item>
						</Grid>
						
						<Grid item xs={6}>
							<Item><div>Start:</div> <span style={{textWrap: 'nowrap'}}>{props.sObj.sdate}</span></Item>
						</Grid>
						<Grid item xs={6}>
							<Item><div>Last:</div> {props.sObj.edate}</Item>
						</Grid>
						<Grid
							item
							xs={12}
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<BootstrapButton
								variant="contained"
								aria-label="delete"
								endIcon={<ShowChartIcon />}
								color="primary"
								disableRipple
								onClick={() => {
									props.getData(props.sObj.name);
									console.log('click button');
								}}
                                sx={{marginTop: '10px'}}
							>
								Show Data
							</BootstrapButton>
						</Grid>
						
					</Grid>
				</Box>
			</div>
		</Popup>
	);
};
export default MobilePopup;
